import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { PartBomDetails, PartBomDetailsTab } from 'partBoms/components';
import { IPartBom } from 'partBoms/types';
import { Color } from 'theme/enums';

import { UpsertPartBom } from './UpsertPartBom';

export const AddPartBomButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [createdPartBom, setCreatedPartBom] = useState<IPartBom | null>(null);

  const { t } = useTranslation();

  return (
    <>
      <Button
        color={Color.SUCCESS}
        text={t('buttonLabelAddPartBom')}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <UpsertPartBom
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={(partBom: IPartBom) => setCreatedPartBom(partBom)}
      />

      <PartBomDetails
        key={createdPartBom?.id}
        isOpen={!!createdPartBom}
        onClose={() => setCreatedPartBom(null)}
        partBom={createdPartBom}
        defaultTab={PartBomDetailsTab.ITEM_LIST}
      />
    </>
  );
};
